import { store } from '../store'
import { changeLanguage } from '../actions'

const changeLanguageUtil = (selectedLanguage) => {
  store.dispatch(changeLanguage(selectedLanguage))
  localStorage.setItem('rpcPreferredLanguage', selectedLanguage)
}

export default changeLanguageUtil
